var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
let TransferOrder = (_class = class TransferOrder extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantToken", _descriptor, this);
    _initializerDefineProperty(this, "transferOrderId", _descriptor2, this);
    _initializerDefineProperty(this, "orderNumber", _descriptor3, this);
    _initializerDefineProperty(this, "state", _descriptor4, this);
    _initializerDefineProperty(this, "sourceLocation", _descriptor5, this);
    _initializerDefineProperty(this, "destinationLocation", _descriptor6, this);
    _initializerDefineProperty(this, "trackingNumber", _descriptor7, this);
    _initializerDefineProperty(this, "expectedOnUnixMillis", _descriptor8, this);
    _initializerDefineProperty(this, "updatedOn", _descriptor9, this);
    _initializerDefineProperty(this, "hasPendingItems", _descriptor10, this);
    _initializerDefineProperty(this, "notes", _descriptor11, this);
    _initializerDefineProperty(this, "numberOfLines", _descriptor12, this);
    _initializerDefineProperty(this, "totalPendingItems", _descriptor13, this);
    _initializerDefineProperty(this, "createdAt", _descriptor14, this);
    _initializerDefineProperty(this, "createdByEmploymentToken", _descriptor15, this);
    _initializerDefineProperty(this, "totalItemCount", _descriptor16, this);
    _initializerDefineProperty(this, "completedAt", _descriptor17, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantToken", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "transferOrderId", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "orderNumber", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "state", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sourceLocation", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "destinationLocation", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "trackingNumber", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "expectedOnUnixMillis", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "updatedOn", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hasPendingItems", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "notes", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "numberOfLines", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "totalPendingItems", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "createdByEmploymentToken", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "totalItemCount", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "completedAt", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransferOrder as default };